import { createFileRoute, redirect } from '@tanstack/react-router'

import { DevButtonsPage } from '@/features/dev-ui'

export const Route = createFileRoute('/_authenticated/_main/dev/botoes')({
  beforeLoad: () => {
    if (import.meta.env.PROD) {
      throw redirect({ to: '/$' })
    }
  },
  component: DevButtonsPage
})
